export const KLYDO_YELLOW = "#FFD848";
export const KLYDO_BLACK = "#0C0C0C";
export const KLYDO_WHITE = "#fdfdfd";
export const KLYDO_GREY = "#6c757d";
